module.exports = __webpack_public_path__ + "static/img/10.4ed7551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/10.png
// module id = ui2u
// module chunks = 0